define('modules/files/files_view',[
  'backbone',
  'jquery',
  '_',

  'modules/loading/loading_spinner_view',
  'modules/pagination/pagination_view',
  'modules/order_table/order_table',

  './files_collection',

  'text!./files_template.html'
], function (Backbone, $, _,
             Loading,
             PaginationView,
             orderTable,
             FilesCollection,
             files_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {

      _.extend(this, opts);

      this.pagination = false;
      this.collection = false;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = new FilesCollection();

      this.listenTo(this.collection, 'request', loading.start.bind(loading));

      this.listenTo(this.collection, 'destroy', function (collection) {
        loading.done();
      });

      this.listenTo(this.collection, 'sync', function (collection) {
        loading.done();
      }, this);

    },

    hasSidebar: false,
    subViews: [],
    className: 'file-list-container',

    template: _.template(files_template),

    events: {
      'click .file-header-item [data-order-by]': 'orderTableHandler'
    },

    orderTableHandler: function (e) {
      e.preventDefault();
      orderTable($(e.currentTarget), this.collection);
    },

    render: function () {
      this.$el.html(this.template(this.collection.params));
      return this;
    },

    renderPagination: function () {
      if (this.pagination) {
        this.pagination.remove();
      }

      this.pagination = new PaginationView(this.collection);
      this.subViews.push(this.pagination);

      this.$el.append(this.pagination.$el);
      this.pagination.delegateEvents();
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.remove();
      this.stopListening();
      return this;
    }

  });
  return View;
});

